import React, { useState } from 'react';
import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';
import { useStatelessGet } from 'hooks/useStatelessGet';
import { useMountEffect } from 'hooks/useMountEffect';

export const SchoolSubjectsField = ({
	value,
	label,
	name,
	required,
	onChange,
	error,
	disabled,
}) => {
	const getSubjects = useStatelessGet('/subjects');
	const [subjects] = useState(new Map());
	const val = value ? value.map((v) => v.id || v) : [];

	useMountEffect(() => {
		getSubjects().then((response: any) => {
			response.data
				.sort((a, b) => {
					const x = a.name.toLowerCase();
					const y = b.name.toLowerCase();
					return x < y ? -1 : x > y ? 1 : 0;
				})
				.forEach((s) => {
					subjects.set(s.id, s.name);
				});
		});
	});

	return (
		<FormControl fullWidth required={required}>
			<FormLabel id={`${name}-label`}>{label}</FormLabel>
			<Autocomplete
				multiple
				disableClearable
				disablePortal
				// @ts-expect-error TS(2322): Type '{ multiple: true; disableClearable: true; di... Remove this comment to see the full error message
				name={name}
				aria-labelledby={`${name}-label`}
				size="small"
				options={Array.from(subjects.keys())}
				getOptionLabel={(o) => subjects.get(o)}
				value={val}
				renderInput={(params) => {
					return (
						<TextField
							{...params}
							required={required}
							disabled={Boolean(disabled)}
							error={Boolean(error)}
							placeholder="Select subject"
						/>
					);
				}}
				onChange={(_, v) => onChange(v)}
			/>
		</FormControl>
	);
};
